import { render, staticRenderFns } from "./biomarkerNetwork.vue?vue&type=template&id=45d01fc8&scoped=true"
import script from "./biomarkerNetwork.vue?vue&type=script&lang=js"
export * from "./biomarkerNetwork.vue?vue&type=script&lang=js"
import style0 from "./biomarkerNetwork.vue?vue&type=style&index=0&id=45d01fc8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d01fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d01fc8')) {
      api.createRecord('45d01fc8', component.options)
    } else {
      api.reload('45d01fc8', component.options)
    }
    module.hot.accept("./biomarkerNetwork.vue?vue&type=template&id=45d01fc8&scoped=true", function () {
      api.rerender('45d01fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/biomarkerNetwork.vue"
export default component.exports